import React from 'react';

import styles from './accountList.module.scss';
import i18n from 'i18n';

import { AccountListProps } from './AccountListModel';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import { Account } from 'core/auth/Account';

export class AccountList extends React.Component<AccountListProps> {
  render() {
    const model = this.props.model;
    const hasPagination = !!model.pagination;
    return (
      <div className={styles.accountList}>
        <StickableTanstackTable<Account>
          hover
          keyField='id'
          key={model.selectedAccounts.join(',')}
          data={model.accounts}
          columns={model.columns}
          defaultSorted={model.defaultSorts}
          noDataIndication={i18n.t(model.noDataDescription)}
          remote={hasPagination}
          onTableChange={model.onTableChange}
          pagination={
            hasPagination
              ? {
                  page: model.pagination.page,
                  sizePerPage: model.pagination.size,
                  totalSize: model.pagination.totalCount
                }
              : undefined
          }
        />
      </div>
    );
  }
}
